//const PROTOCOLO = 'http'; // Mude para 'https' em produção
//const ENDERECO = 'localhost:5000'; // Mude para o seu domínio de produção, ex: 'api.meusite.com'
const PROTOCOLO = 'https'; // Mude para 'https' em produção
const ENDERECO = 'srv690508.hstgr.cloud:5000';
// URL base para a sua API
export const API_BASE_URL = `${PROTOCOLO}://${ENDERECO}`;